export { default } from "./Avatars";
